/* TODO: t() */
import React from 'react';
import FormView from './BooleanElement/BooleanElementFormView';
import FieldEditor from './BooleanElement/BooleanElementFieldEditorView';
import EditView from './BooleanElement/BooleanElementEditView';
import { Icon } from '../../uiold';
import FormElementBase from '../FormElementBase';

import IndexedList from '../../../support/shared/IndexedList';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';
import { OptionValue } from '../../../types/FormBuilder/FormElements';
import { Market } from '../../../types/shared/Market';
import { Field } from '../../../types/shared/Vendor';

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: boolean | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type Props = {
  value?: boolean;
  onChange?: (id: string, value: boolean) => void;
};

class BooleanElement extends FormElementBase {
  static getType() {
    return 'BooleanElement';
  }

  static getDescription() {
    return 'Yes or No';
  }

  static getAttributes() {
    return {
      name: 'Yes or No',
      label: 'Yes or No',
      default_value: false,
      use_checkbox: false,
      hidden: false,
      require_acceptance: false,
      is_public: false,
    };
  }

  static getIconName() {
    return 'radioButton';
  }

  static getIcon() {
    return <Icon name="radioButton" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        readOnly={true}
      />
    );
  }

  renderFormView(props?: Props) {
    props = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { value } = props;
    let { definition } = this;
    // Don't render yes/no fields that require a "yes".
    if (definition.require_acceptance) {
      return null;
    }
    return <span>{value ? 'Yes' : 'No'}</span>;
  }

  renderEditView(props: Props) {
    let { definition } = this;
    // Don't render yes/no fields that require a "yes".
    if (definition.require_acceptance) {
      return null;
    }
    // There was a bug in EditView that was stringifying boolean values.
    if (typeof props.value !== 'boolean') {
      props = { ...props, value: String(props.value) === 'true' };
    }
    return (
      <EditView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  getValueAsOptions(): Array<OptionValue> {
    return [
      {
        id: 'true',
        name: 'Yes',
        value: true,
      },
      {
        id: 'false',
        name: 'No',
        value: false,
      },
    ];
  }
}

export default BooleanElement;
